<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="showDisplayForm"
            :item="selectedType"
            @success="alertSuccess"
            @danger="alertDanger"
            @delete-item="deleteType"
            @error="showError"
            @cancel="cancel"
        ></view-item>

        <list-items
            v-else
            title="Review Types"
            :items="checkoffTypes"
            @show-item="showItem"
            ref="table"
        >
            <b-row>
                <b-col offset="8" class="text-right">
                    <b-button variant="primary" @click="addType"
                        >Add Type</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'CheckoffType',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins],
    data: () => {
        return {
            showDisplayForm: false,
            componentName: 'Review Type',
        }
    },

    created() {
        this.$store.dispatch('roles/fetchAll')
        this.$store.dispatch('checkoffTypes/fetchAll')
    },
    computed: {
        checkoffTypes() {
            const types = this.$store.state.checkoffTypes.types
            console.log('types', types)
            return types
        },
        selectedType() {
            const selectedType = this.$store.state.checkoffTypes.selectedType
            console.log('selectedType', selectedType)
            return selectedType
        },
    },
    watch: {
        'selectedType.id': function (to) {
            if (to) this.showDisplayForm = true
        },
    },

    methods: {
        /* cancel() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = false
        }, */

        cancel() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = false
            this.$store.dispatch('checkoffTypes/fetchAll')
        },

        showItem(id) {
            this.$store.dispatch('checkoffTypes/fetchById', id)
        },

        alertSuccess(action, name) {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = false
            this.genericToast(
                this.componentName,
                action,
                'success',
                `${name} has been succcessfully ${action.toLowerCase()}`
            )
        },
        alertDanger(action,message) {

            this.genericToast(
                this.componentName,
                action,
                'danger',
                message,
            )

        },


        addType() {
            this.$store.commit('checkoffTypes/SET_NULL_TYPE')
            this.showDisplayForm = true
        },
    },
}
</script>
<style></style>
